import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

import type { FilterModal } from '@/components/customisable-ribbon/customisableRibbonModalSchema';
import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetTypes } from './config';

export const useGetDefaultRibbonFilters = (): FilterModal[] => {
  const types = useGetTypes();
  const { t } = useTranslation(['common'], {
    keyPrefix: 'myItems.dashboard',
  });

  const policyModuleEnabled = useIsFeatureVisibleToOrg('policy');
  const complianceModuleEnabled = useIsFeatureVisibleToOrg('compliance');

  if (!policyModuleEnabled) {
    delete types['document'];
  }
  if (!complianceModuleEnabled) {
    delete types['obligation'];
  }

  const typeLabels = Object.values(types);

  return useMemo<FilterModal[]>(() => {
    const filters: FilterModal[] = (typeLabels ?? []).map((label) => ({
      id: uuidv4(),
      title: label,
      itemFilterQuery: {
        tokens: [],
        tokenGroups: [
          {
            operator: '=',
            propertyKey: 'Type',
            value: label,
          },
        ],
        operation: 'and',
      },
    }));

    return [
      ...filters,
      {
        id: uuidv4(),
        title: t('all'),
        itemFilterQuery: {
          tokens: [],
          tokenGroups: [],
          operation: 'and',
        },
      },
    ];
  }, [typeLabels, t]);
};
